export default __webpack_public_path__ + "static/media/avatar1.ae53331a.svg";